import { render, staticRenderFns } from "./FormCotizacion.vue?vue&type=template&id=ad2c8aca&scoped=true&"
import script from "./FormCotizacion.vue?vue&type=script&lang=ts&"
export * from "./FormCotizacion.vue?vue&type=script&lang=ts&"
import style0 from "./FormCotizacion.vue?vue&type=style&index=0&id=ad2c8aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2c8aca",
  null
  
)

export default component.exports